import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Collections } from './components/Collections';
import { NewCollection } from './components/NewCollection';
import { WoolCollection } from './components/WoolCollection';
import { Catalog } from './components/Catalog';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { InstagramGallery } from './components/InstagramGallery';
import { FAQ } from './components/FAQ';
import { Delivery } from './components/Delivery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWidget } from './components/FloatingWidget';
export function App() {
  return <div className="min-h-screen bg-brand-cream" data-id="element-0" data-mp="2wip2ssgwz006">
      <Header data-id="element-1" data-mp="28tmfb3zlmcxr" />
      <main data-id="element-2" data-mp="28te4dhn1dhp7">
        <Hero data-id="element-3" data-mp="28sutgkvsztko" />
        <Collections data-id="element-4" data-mp="28sbbj465l56n" />
        <NewCollection data-id="element-5" data-mp="23vchelmhoy8g" />
        <WoolCollection data-id="element-6" data-mp="23w4fq47h1a2f" />
        <Catalog data-id="element-7" data-mp="23ujl6el5pr4k" />
        <About data-id="element-8" data-mp="23v2td3l0915e" />
        <Testimonials data-id="element-9" data-mp="23ti7018ugoim" />
        <InstagramGallery data-id="element-10" data-mp="3ikh8gaq64uzi" />
        <FAQ data-id="element-11" data-mp="3iiwasc8k4vxf" />
        <Delivery data-id="element-12" data-mp="3ijfvg0pldyf5" />
        <Contact data-id="element-13" data-mp="3ihv0wb3a2fha" />
      </main>
      <Footer data-id="element-14" data-mp="3mlat8v8bdto6" />
      <FloatingWidget data-id="element-15" data-mp="3mkrc3gqhn9b7" />
    </div>;
}